<template>
  <div
    id="committee"
  >
    <v-row>
      <v-col>
        <h1>Hackathon Committee</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-skeleton-loader
          v-if="loading"
          type="list-item"
        />
        <div
          v-else
        >
          <v-card>
            <v-list-item
              v-for="person in committee"
              :key="generateKeyFromEmail(person.email)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ person.name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-icon
                v-if="isCommitteeMember"
              >
                <v-icon
                  @click="removeCommitteeMember(person.email)"
                >
                  mdi-account-remove
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div
          v-if="isCommitteeMember"
        >
          <h2 style="margin-top: 1rem;">
            Committee Actions
          </h2>
          <v-row style="margin: 0 -20px;">
            <v-col cols="4">
              <CommitteeAdd
                :client="committeeClient"
                @submit="getCommitteeMembers"
              />
            </v-col>
            <v-col cols="4">
              <CreateEvent
                :client="eventClient"
                :committee="committee"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable import/no-cycle */
import CommitteeClient from '@/api/CommitteeClient';
import EventsClient from '@/api/EventsClient';
import CommitteeAdd from '@/components/CommitteeAdd.vue';
import CreateEvent from '@/components/CreateEvent.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Committee',
  components: {
    CommitteeAdd,
    CreateEvent,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      committee: [],
      loading: true,
      newEmail: '',
    };
  },
  computed: {
    isCommitteeMember() {
      return this.committee.filter((person) => person.email === this.currentUser.email).length;
    },
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
  },
  mounted() {
    this.eventId = this.$store.state.hackathonID || null;
    this.committeeClient = new CommitteeClient(this.currentJwtToken);
    this.eventClient = new EventsClient(this.currentJwtToken);
    this.getCommitteeMembers();
  },
  methods: {
    async getCommitteeMembers() {
      this.loading = true;
      const responseData = await this.committeeClient.getCommitteeMembers();
      this.committee = responseData;
      this.loading = false;
    },
    generateKeyFromEmail(userEmail) {
      // will replace this with api call
      return userEmail.replace(/\s+/g, '-').toLowerCase().replace('.', '-').replace('@', '-');
    },
    async removeCommitteeMember(email) {
      await this.committeeClient.removeMember(email);
      this.committee = this.committee.filter((person) => person.email !== email);
    },
  },
};
</script>

<style lang="scss" scoped>
#committee {
  background: white;
  padding: 1em;
}
</style>
